/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendarAlt} from '@fortawesome/pro-duotone-svg-icons';

const CalendarIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCalendarAlt} {...props} />
);

export default CalendarIcon;
